import GLogo from 'students/views/shared/assets/providers/google/google-logo.png';
import FBLogo from 'students/views/shared/assets/providers/facebook/facebook-logo.png';
import MSLogo from 'students/views/shared/assets/providers/microsoft/microsoft-logo.png';
import AppleLogo from 'students/views/shared/assets/providers/apple/apple-logo.png';
import FeideLogo from 'students/views/shared/assets/providers/feide/feide-logo.png';

import GLogoWebp from 'students/views/shared/assets/providers/google/google-logo.webp';
import FBLogoWebp from 'students/views/shared/assets/providers/facebook/facebook-logo.webp';
import MSLogoWebp from 'students/views/shared/assets/providers/microsoft/microsoft-logo.webp';
import AppleLogoWebp from 'students/views/shared/assets/providers/apple/apple-logo.webp';
import FeideLogoWebp from 'students/views/shared/assets/providers/feide/feide-logo.webp';

import GLogoSVG from 'students/views/shared/assets/providers/google/google-logo.svg';
import FBLogoSVG from 'students/views/shared/assets/providers/facebook/facebook-logo.svg';
import MSLogoSVG from 'students/views/shared/assets/providers/microsoft/microsoft-logo.svg';
import AppleLogoSVG from 'students/views/shared/assets/providers/apple/apple-logo.svg';
import FeideLogoSVG from 'students/views/shared/assets/providers/feide/feide-logo.svg';

import { tProviderVisibility } from './providerVisibility';

export interface ISocialProvider {
  link: string;
  providerName: string;
  logo: string;
  webpLogo: string;
  fallbackLogo: string;
  visibility: tProviderVisibility;
}

const socials: ISocialProvider[] = [
  {
    link: '/auth/google_student?popup=true',
    providerName: 'Google',
    logo: GLogoSVG,
    webpLogo: GLogoWebp,
    fallbackLogo: GLogo,
    visibility: { kind: 'always' }
  },
  {
    link: '/auth/facebook_student?popup=true',
    providerName: 'Facebook',
    logo: FBLogoSVG,
    webpLogo: FBLogoWebp,
    fallbackLogo: FBLogo,
    visibility: { kind: 'more' }
  },
  {
    link: '/auth/microsoft_student?popup=true',
    providerName: 'Microsoft',
    logo: MSLogoSVG,
    webpLogo: MSLogoWebp,
    fallbackLogo: MSLogo,
    visibility: { kind: 'always' }
  },
  {
    link: '/auth/apple_student?popup=true',
    providerName: 'Apple',
    logo: AppleLogoSVG,
    webpLogo: AppleLogoWebp,
    fallbackLogo: AppleLogo,
    visibility: { kind: 'apple' }
  },
  {
    link: '/auth/feide_student?popup=true',
    providerName: 'FEIDE',
    logo: FeideLogoSVG,
    webpLogo: FeideLogoWebp,
    fallbackLogo: FeideLogo,
    visibility: { kind: 'norway' }
  }
];

export default socials;
